// Chakra imports
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { ApexOptions } from "apexcharts";
// Custom components
import Card from "components/Card/Card";
import { formatedDateBr } from "helpers/formated";
import ReactApexChart from "react-apexcharts";
// Assets

export default function TotalSpentDay(data: any) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const themeTooltip = useColorModeValue("light", "dark");
  const bgLoading = useColorModeValue("white", "#111C44");

  const seriesData = [
    {
      name: "Agendado",
      data: [
        data?.data?.dataShowingFerragem[0],
        data?.data?.dataShowingChaparia[0],
      ],
    },
    {
      name: "Disponível",
      data: [
        data?.data?.dataShowingFerragem[1],
        data?.data?.dataShowingChaparia[1],
      ],
    },
    {
      name: "Excedido",
      data: [
        data?.data?.dataShowingFerragem[2],
        data?.data?.dataShowingChaparia[2],
      ],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      formatter: function (val: number) {
        return val ? val + "%" : "";
      },
    },
    xaxis: {
      categories: ["Ferragem", "Chaparia"],
      labels: {
        style: {
          colors: textColor,
        },
      },
    },
    yaxis: {
      min: 0,
      labels: {
        style: {
          colors: textColor,
        },
      },
    },

    colors: ["#368d61", "#FFD700", "#FF0000"],
    tooltip: {
      theme: themeTooltip,
      y: {
        formatter: function (val: any) {
          return val + "%"; // Adiciona o símbolo de porcentagem apenas no tooltip
        },
      },
    },

    legend: {
      labels: {
        colors: textColor,
      },
    },
  };
  return (
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      mb="0px"
      bg={bgLoading}
    >
      <Flex w="100%" flexDirection={{ base: "column", lg: "row" }}>
        <Flex flexDirection="column" me="20px" mt="28px">
          <Text
            color={textColor}
            fontSize="24px"
            textAlign="start"
            fontWeight="700"
            lineHeight="100%"
          >
            {formatedDateBr(data?.data?.day)}
          </Text>
        </Flex>
      </Flex>
      <Flex w="100%" flexDirection={{ base: "column", lg: "row" }}>
        <Box minH="360px" minW="90%" mt="auto">
          <ReactApexChart
            options={options as ApexOptions}
            series={seriesData}
            type="bar"
            height={350}
          />
        </Box>
      </Flex>
    </Card>
  );
}
